const faqItems = [
  {
    question: "Will this actually help me or is it just another AI app?",
    answer:
      "Shattara AI is a personalized AI tutor designed for students, teachers, and learners of all ages. Whether you're struggling with homework, preparing for exams, or exploring new subjects, our intelligent tutoring system adapts to your unique learning style and pace.",
  },
  {
    question: "How fast will I see a difference in my grades?",
    answer:
      "Our AI analyzes your learning patterns, strengths, and areas for improvement in real-time. It adjusts explanations, provides targeted practice problems, and recommends resources based on your progress — ensuring every session is tailored to help you succeed.",
  },
  {
    question: "Can I use this to prepare for tomorrow's exam?",
    answer:
      "Shattara AI supports a wide range of subjects including mathematics, science, languages, history, and more. From elementary concepts to advanced university-level material, our AI tutor is equipped to help you master any topic.",
  },
  {
    question: "My parents are skeptical. What should I tell them?",
    answer:
      "Absolutely. Shattara AI provides step-by-step explanations, guides you through problem-solving processes, and helps you understand concepts rather than just giving answers — empowering you to learn and grow independently.",
  },
  {
    question: "Is this better than hiring a private tutor?",
    answer:
      "Our platform tracks your learning journey with detailed analytics, showing your improvement over time, identifying knowledge gaps, and celebrating milestones. You'll always know where you stand and what to focus on next.",
  },
  {
    question: "Is my data safe? Does Shattara share or sell it?",
    answer:
      "Yes. We use enterprise-grade encryption and follow strict privacy standards to protect your personal information and learning data. Your progress, questions, and academic records are completely secure and confidential.",
  },
  {
    question: "How do I start and how long does setup take?",
    answer:
      "Getting started is easy! Sign up for free — no credit card required. Start learning immediately with our AI tutor, or book a demo to see how personalized AI tutoring can transform your educational journey.",
  },
];

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Shattara AI",
  url: "https://shattaraai.com",
  logo: "https://storage.googleapis.com/gpt-engineer-file-uploads/PnpYQ480QAO6BinAcI1aHr1rU8c2/uploads/1771058217700-newlogo_light.png",
  sameAs: [
    "https://twitter.com/ShattaraAI",
  ],
};

const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Shattara AI",
  applicationCategory: "EducationalApplication",
  operatingSystem: "Web",
  url: "https://shattaraai.com",
  description:
    "AI-powered personalized tutor for students. Upload your materials and get instant explanations, quizzes, and flashcards tailored to your syllabus.",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    description: "Free plan available",
  },
};

const faqPageSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.answer,
    },
  })),
};

export const HomepageStructuredData = () => {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(softwareApplicationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
      />
    </>
  );
};
